import { defineComponent } from '@vue/composition-api';
// 搭积木动画组件
export const BuildingBlocksAnimation = defineComponent({
    name: 'BuildingBlocksAnimation',
    props: {
        fullscreen: {
            type: Boolean,
            default: false,
        },
        text: {
            type: String,
            default: '',
        },
    },
    render() {
        const isFullscreen = this.fullscreen;
        const loadingText = this.text;
        return (<div class={`building-blocks-wrapper ${isFullscreen ? 'fullscreen' : 'inline'}`}>
        <div class="building-blocks-container">
          <div class="building-blocks">
            <div class="block block-1"/>
            <div class="block block-2"/>
            <div class="block block-3"/>
          </div>
          {loadingText && (<div class="loading-text">{loadingText}</div>)}
        </div>
        <style>
          {`
            .building-blocks-wrapper {
              display: flex;
              align-items: center;
              justify-content: center;
              background: rgba(250, 250, 250, 0.9);
              border-radius: 4px;
              z-index: 10;
            }
            .building-blocks-wrapper.inline {
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
            }
            .building-blocks-wrapper.fullscreen {
              position: fixed;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
              z-index: 9999;
            }
            .building-blocks-container {
              display: flex;
              flex-direction: column;
              align-items: center;
              gap: 16px;
            }
            .building-blocks {
              position: relative;
              width: 36px;
              height: 36px;
            }
            .block {
              position: absolute;
              width: 10px;
              height: 10px;
              background: #1e304a;
              border-radius: 2px;
            }
            .block-1 {
              left: 13px;
              bottom: 0;
              animation: drop1 1.2s ease-in-out infinite;
            }
            .block-2 {
              left: 2px;
              bottom: 10px;
              animation: drop2 1.2s ease-in-out infinite;
              animation-delay: 0.2s;
            }
            .block-3 {
              left: 24px;
              bottom: 10px;
              animation: drop3 1.2s ease-in-out infinite;
              animation-delay: 0.4s;
            }
            .loading-text {
              color: #1e304a;
              font-size: 14px;
              font-weight: 500;
              white-space: nowrap;
            }
            @keyframes drop1 {
              0%, 100% { transform: translateY(-20px); opacity: 0; }
              20%, 80% { transform: translateY(0); opacity: 1; }
            }
            @keyframes drop2 {
              0%, 100% { transform: translateY(-20px); opacity: 0; }
              30%, 80% { transform: translateY(0); opacity: 1; }
            }
            @keyframes drop3 {
              0%, 100% { transform: translateY(-20px); opacity: 0; }
              40%, 80% { transform: translateY(0); opacity: 1; }
            }
          `}
        </style>
      </div>);
    },
});
